import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  clusterNumber: number;
  isHovered?: boolean;
};

const ClusterMarker: React.FC<Props> = ({ clusterNumber, isHovered }) => {
  return (
    <div
      className={cn(
        "marker-shadow rounded-full border border-pure-black/5 px-4 py-2",
        isHovered
          ? "bg-pure-black text-pure-white"
          : "bg-pure-white text-pure-black"
      )}
    >
      {clusterNumber} hotels
    </div>
  );
};

export default ClusterMarker;
